import { Callout } from '@studio/design-system/callout';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { CaveatProps } from './types.js';

/** `<Caveat>` component. */
export const Caveat = ({ className, title, ...props }: CaveatProps): ReactElement => (
  <Callout
    className={twMerge('w-full p-8', className)}
    title={<p className='text-sm font-regular text-muted'>{title}</p>}
    {...props}
  />
);
